import { Spine } from "@esotericsoftware/spine-pixi-v8";
import { sound } from "@pixi/sound";
import { isSuperQuickBtnOnGlobal, RespinIndex } from "../../config/GlobalVariableConfig";
import { DisplayObject, IDisplayObject } from "../../core/displays/DisplayObject";
import { SoundConstants } from "../../gameClientEvents/SoundConstants";
import { ISpineData } from "../../interfaces";
import { reelSpinEmitter } from "../../reels/ReelInit";
import { spinData } from "../../server/getServerResposesFun";

export class Meter extends DisplayObject {

    private symbolConfig: Record<number, ISpineData> = {
        1: { skeleton: "meter_lv5_skel", atlas: "meter_lv5_atlas" },
        2: { skeleton: "meter_lv4_skel", atlas: "meter_lv4_atlas" },
        3: { skeleton: "meter_lv3_skel", atlas: "meter_lv3_atlas" },
        4: { skeleton: "meter_lv2_skel", atlas: "meter_lv2_atlas" },
        5: { skeleton: "meter_lv1_skel", atlas: "meter_lv1_atlas" },
        6: { skeleton: "meter_hv5_skel", atlas: "meter_hv5_atlas" },
        7: { skeleton: "meter_hv4_skel", atlas: "meter_hv4_atlas" },
        8: { skeleton: "meter_hv3_skel", atlas: "meter_hv3_atlas" },
        9: { skeleton: "meter_hv2_skel", atlas: "meter_hv2_atlas" },
        10: { skeleton: "meter_hv1_skel", atlas: "meter_hv1_atlas" },
    };

    private symbols: Record<number, Spine> = {};

    constructor(config: IDisplayObject) {
        super(config);
        this.hide();
        const ids = Object.keys(this.symbolConfig).map(Number);
        this.createInstances(ids);
        let progress = spinData?.respins[RespinIndex.value - 2]?.featureData?.fortuneMeter
        for (let i = 0; i < progress; i++) {
            if (spinData.respins[RespinIndex.value].type === "fs_reveal") {
                this.static(i + 1);
            }
        }
        this.subscribeToEvents();
    }

    public override destroy(options?: boolean | undefined): void {
        this.unSubscribeToEvents();
        super.destroy(options);
    }

    public show() {
        this.visible = true;
    }

    public hide() {
        this.visible = false;
    }

    public activate(id: number, callback: () => void) {
        const symbol = this.getSymbolByID(id);
        let timescale = isSuperQuickBtnOnGlobal ? 2 : 1;
        let listener = {
            complete: () => {
                symbol.state.removeListener(listener);
                const originalIndex = parseInt(symbol.label) - 1;
                this.setChildIndex(symbol, originalIndex);
                this.static(id);
                callback();
            }
        };
        this.setChildIndex(symbol, this.children.length - 1);
        symbol.state.timeScale = timescale;
        symbol.state.addListener(listener);
        sound.play(SoundConstants.TOMBSTONE_HIGHLIGHTED,{ volume: 1 });
        symbol.state.setAnimation(0, 'active', false);
    }

    public deActivate(id: number) {
        const symbol = this.getSymbolByID(id);
        symbol.state.setAnimation(0, 'deactive', false);
    }

    public static(id: number) {
        const symbol = this.getSymbolByID(id);
        symbol.state.setAnimation(0, 'static', false);
    }

    private subscribeToEvents() {
        if (spinData?.respins[RespinIndex.value]?.type === "fs_reveal") {
            return;
        }
        reelSpinEmitter.on("resetWins", this.deactivateAll, this);
    }

    private unSubscribeToEvents() {
        reelSpinEmitter.off("resetWins", this.deactivateAll, this);
    }

    private deactivateAll() {
        for (const symbol of Object.values(this.symbols)) {
            symbol.state.setAnimation(0, 'deactive', false);
        }
    }

    private getSymbolByID(id: number): Spine {
        return this.symbols[id];
    }

    private createInstances(symbolIds: number[], spacing: number = 83) {
        let startx: number = -375;
        symbolIds.forEach((id, index) => {
            const config = this.symbolConfig[id];

            const spineAnim = Spine.from({
                skeleton: config.skeleton,
                atlas: config.atlas,
            });

            spineAnim.x = startx + (spacing * index);
            spineAnim.y = 0;

            spineAnim.label = id.toString();

            spineAnim.state.setAnimation(0, 'deactive', false);
            this.addChild(spineAnim);
            this.symbols[id] = spineAnim;
        });
    }
}
